import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableConfig } from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceService } from '../device/device.service';
import { DeviceFactory } from '../device/device-factory/device-factory';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { SiteDashboardService } from '../site-dashboard.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { SitesService } from 'src/app/sites/sites.service';
import * as _ from 'lodash-es';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { DecimalPipe } from '@angular/common';

@Component({
	selector: 'app-site-truck-reports',
	templateUrl: './site-truck-reports.component.html',
	styleUrls: ['./site-truck-reports.component.css']
})

export class SiteTruckReportsComponent implements OnInit {
	DeviceFactory = DeviceFactory;
	siteInfo: any = {};
	siteInstallationDate = null;
	subSite: Subscription = new Subscription();
	toDate = new Date((new Date()).getTime() - 24 * 60 * 60 * 1000); // yesterday
	fromDate = new Date((new Date()).getTime() - (30 * 24 * 60 * 60 * 1000)); // 30 days ago
	minDate = moment(0).toDate();
	truckDevicesTypes = [DeviceFactory.types.iotah];

	yearList: any[] = [];
	selectedYear: number = new Date().getFullYear();
	selectedPeriodType = 'monthly';
	truckTypeList: any[] = [{value: 'all', label: this.translateService.instant('site_performance.all_truck_types')}];
	noData: boolean = false;
	monthlyQuarterlyNoData = false;
	/************* Truck Usage Report *************/
	dailyTruckUsageReportsConfig = {
		column: [
			{ key: 'day', name: this.translateService.instant('g.date'), type: 'date' },
			{ key: 'trucks_count', name: this.translateService.instant('site_trucks_report.total_trucks'), type: 'number' },
			{ key: 'used_trucks_count', name: this.translateService.instant('site_trucks_report.total_used_trucks'), type: 'number' },
			{ key: 'total_truck_score', name: this.translateService.instant('site_trucks_report.truck_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.site_usage_utilization_score_column') },
			{ key: 'total_inuse_ah', name: this.translateService.instant('site_trucks_report.total_daily_ah'), type: 'number' },
			{ key: 'total_truck_energy_score', name: this.translateService.instant('site_trucks_report.energy_truck_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.site_usage_energy_utilization_score_column') },
			{ key: 'total_kwh_used', name: this.translateService.instant('truck_performance.total_kwh_used'), type: 'number' },
			{ key: 'total_in_use_hours', name: this.translateService.instant('truck_performance.total_in_use_hours'), type: 'number' },
			{ key: 'total_travel_hours', name: this.translateService.instant('truck_performance.total_travel_hours'), type: 'number' },
			{ key: 'total_lift_hours', name: this.translateService.instant('truck_performance.total_lift_hours'), type: 'number' },
			{ key: 'total_idle_hours', name: this.translateService.instant('truck_performance.total_idle_hours'), type: 'number' },
			{ key: 'total_off_charging_hours', name: this.translateService.instant('truck_performance.total_off_charging_hours'), type: 'number' },
		],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('utilization.daily_truck_usage_report'),
			csvFileHeaderInfo: [],
		} as TableConfig
	}
	selectedDailyUsageTruckTypeFilter = this.truckTypeList[0].value;
	invalidTruckUsageDate: boolean = false;
	/**************  Monthly Quarterly Truck Usage report ******************/
	monthlyQuarterlyTruckReport = {
		column: [
			{key: 'period', name: this.translateService.instant('connectivity_verification.month'), type: 'string'},
			{ key: 'trucks_count', name: this.translateService.instant('site_trucks_report.total_trucks'), type: 'number' },
			{ key: 'used_trucks_count', name: this.translateService.instant('site_trucks_report.total_used_trucks'), type: 'number', hasTooltip: this.translateService.instant('tooltip.site_monthly_number_of_used_column') },
			{ key: 'score', name: this.translateService.instant('site_trucks_report.truck_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.site_monthly_usage_utilization_score_column') },
			{ key: 'total_inuse_ah', name: this.translateService.instant('site_trucks_report.total_daily_ah'), type: 'number' },
			{ key: 'energy_truck_score', name: this.translateService.instant('site_trucks_report.energy_truck_score'), type: 'number', hasTooltip: this.translateService.instant('tooltip.site_monthly_energy_utilization_score_column') },
			{ key: 'total_kwh_used', name: this.translateService.instant('truck_performance.total_kwh_used'), type: 'number' },
			{ key: 'total_in_use_hours', name: this.translateService.instant('truck_performance.total_in_use_hours'), type: 'number' },
			{ key: 'total_travel_hours', name: this.translateService.instant('truck_performance.total_travel_hours'), type: 'number' },
			{ key: 'total_lift_hours', name: this.translateService.instant('truck_performance.total_lift_hours'), type: 'number' },
			{ key: 'total_idle_hours', name: this.translateService.instant('truck_performance.total_idle_hours'), type: 'number' },
			{ key: 'total_off_charging_hours', name: this.translateService.instant('truck_performance.total_off_charging_hours'), type: 'number' },
		],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('chargers_performance.monthly_quarterly_usage_report'),
			csvFileHeaderInfo: [],
		} as TableConfig
	}
	periodTypes = [
		{label: this.translateService.instant('g.monthly'), id: 'monthly'},
		{label: this.translateService.instant('g.quarterly'), id: 'quarterly'},
	];
	selectedMonthlyQuarterlyTruckTypeFilter = this.truckTypeList[0].value;
	monthlyQuarterlyReportData: {};

	/************ Daily Monthly Truck Usage Report ***************/
	selectedGraphTypes = 'total';
	selectedCharts = 'all';
	selectedMonthlyDailyPeriod: string = 'monthly';
	monthlyDailySelectedYear:number = new Date().getFullYear();
	selectedMonthlyDailyTruckTypeFilter = this.truckTypeList[0].value;
	graphTypes = [
		{label: this.translateService.instant('g.total'), id: 'total'},
		{label: this.translateService.instant('g.daily_avg'), id: 'average'},
	];

	dailyMonthlyPeriod = [
		{label: this.translateService.instant('g.monthly'), id: 'monthly'},
		{label: this.translateService.instant('g.daily'), id: 'daily'},
	];

	chartsData = {
		total_inuse_hours: {},
		total_inuse_ah: {},
		total_inuse_kwh: {},
		total_travel_lift_time: {},
		average_inuse_hours: {},
		average_inuse_ah: {},
		average_inuse_kwh: {},
		average_travel_lift_time: {},
	};

	chartObject = {
		config:  {
			legend: 'none',
			bar: {
				groupWidth: 30
			},
			tooltip: {isHtml: true},
		},
		columnNames: ['Time', 'Data'],
		hasData: false
	}
	timeChartConfig: any = {...this.chartObject.config};
	tooltipConfig = { role: 'tooltip', type: 'string', p: {html: false} };
	travelLiftTimeChartColumnNames = ['Time', 'truck travel time', this.tooltipConfig, 'truck lift time', this.tooltipConfig];
	travelLiftTimeChartConfig: any = {};

	powerChartColumnConfig = {
		title: this.translateService.instant('perf_analytic.truck_power_usage_charts'),
		ampChartTitle: this.translateService.instant('fleet_reports.truck_amp_draw'),
		kwChartTitle: this.translateService.instant('fleet_reports.truck_kw_draw'),
	}

	get printFilters(): { label: string, value: string }[] {
		const filters: { label: string, value: string }[] = [
			{ label: 'g.year', value: this.monthlyDailySelectedYear?.toString() },
			{ label: 'perf_analytic.period', value: this.commonService.getOptionLabel(this.dailyMonthlyPeriod, this.selectedMonthlyDailyPeriod) }
		];

		if (this.selectedMonthlyDailyPeriod !== 'daily')
			filters.push({ label: 'g.data', value: this.commonService.getOptionLabel(this.graphTypes, this.selectedGraphTypes) });

		filters.push({ label: 'devices.truck_type', value: this.commonService.getOptionLabel(this.truckTypeList, this.selectedMonthlyDailyTruckTypeFilter) });

		return filters;
	}

	constructor(
		private translateService: TranslateService,
		private deviceService: DeviceService,
		private siteService: SitesService,
		private sideMenuService: SideMenuService,
		private siteDashboardService: SiteDashboardService,
		private commonService: CommonService,
		private notificationMessageService: NotificationMessageService,
	) {}

	ngOnInit() {
		this.subSite = this.sideMenuService.currentSite.subscribe((site: any) => {
			if(!site['id'])
				return;

			this.siteInfo = site;
			this.commonService.setPageTabTitle(`${this.siteInfo.customer_name} - ${this.siteInfo.name} - ${this.translateService.instant('nav.site_trucks_reports')}`);
			this.minDate = moment.utc(this.siteInfo.installation_date).startOf('day').toDate();
			this.siteInstallationDate = moment(site.installation_date).utc().startOf('day').toDate();
			const {yearList, currentYear} =  this.siteDashboardService.prepareYearsList(this.yearList, this.siteInstallationDate);
			this.yearList = yearList;
			this.selectedYear = currentYear;
			this.getSiteDevicesUsageData();
			this.getMonthlyQuarterlyUsageReport();
			this.getMonthlyDailyChartsData();
			this.dailyTruckUsageReportsConfig.config.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
				customerName: this.siteInfo.customer_name,
				siteName: this.siteInfo.name,
				includeSpacing: false
			});

			this.monthlyQuarterlyTruckReport.config.csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
				customerName: this.siteInfo.customer_name,
				siteName: this.siteInfo.name,
				includeSpacing: false
			});

		});
	}

	getSiteDevicesUsageData() {
		this.invalidTruckUsageDate = false;
		this.dailyTruckUsageReportsConfig.data = [];
		const zoneDiff	= new Date().getTimezoneOffset() * -1;
		let fromDate:any	= new Date(new Date(this.fromDate).getTime() + (zoneDiff * 60 * 1000));
		let toDate:any = new Date(new Date(this.toDate).getTime() + (zoneDiff * 60 * 1000));
		fromDate = moment(fromDate).utc().startOf('day').unix();
		toDate = moment(toDate).utc().endOf('day').unix();

		if (fromDate > toDate) {
			this.invalidTruckUsageDate = true;
			return this.notificationMessageService.setMessage('translate|g.invalid_input');
		}

		this.deviceService.getDailyDeviceUsageReport(fromDate, toDate, '', DeviceFactory.types.iotah, this.siteInfo.id, 0,{truckType: this.selectedDailyUsageTruckTypeFilter}).subscribe((res: any) => {
			res = this.prepareWidgetsTruckTypes(res);
			let decimalPipe: DecimalPipe = new DecimalPipe("en-US");

			const tableData = [];
			for (const day in res) {
				if (res.hasOwnProperty(day)) {
					tableData.push({
						day: {value: res[day].day},
						trucks_count: {value: (res[day].trucks_count || 0).toLocaleString()},
						used_trucks_count: {value: (res[day].used_trucks_count || 0).toLocaleString()},
						total_truck_score: {value: Math.round((res[day].truck_score || 0)).toLocaleString()},
						total_inuse_ah: {value: decimalPipe.transform(res[day].total_discharged_as / 3600 || 0, '1.0-1')},
						total_truck_energy_score: {value: Math.round((res[day].truck_energy_score || 0).toLocaleString())},
						total_kwh_used: {value: decimalPipe.transform(res[day].total_ws_used / (3600 * 1000) || 0, '1.0-1')},
						total_in_use_hours: {value: Math.round(res[day].total_in_use_second / 3600 || 0).toLocaleString()},
						total_travel_hours: {value: Math.round(res[day].total_travel_second / 3600 || 0).toLocaleString()},
						total_lift_hours: {value: Math.round(res[day].total_lift_second / 3600 || 0).toLocaleString()},
						total_idle_hours: {value: Math.round(res[day].total_idle_second / 3600 || 0).toLocaleString()},
						total_off_charging_hours: {value: Math.round(res[day].total_off_charging_second / 3600 || 0).toLocaleString()},
					});
				}
			}
			this.dailyTruckUsageReportsConfig.data = tableData;
		});
	}

	changeDate(type, value) {
		this[type] = value;
		this.getSiteDevicesUsageData();
	}

	getMonthlyQuarterlyUsageReport() {
		this.deviceService.getMonthlyQuarterlyChargerUsageReport('', this.selectedYear, DeviceFactory.types.iotah, this.siteInfo.id, 0, {truckType: this.selectedMonthlyQuarterlyTruckTypeFilter}).subscribe((res: any) => {
			this.monthlyQuarterlyReportData = res;
			this.updateTableData(res?.[this.selectedPeriodType]?.[this.selectedYear] || []);
		});
	}

	updateTableData(data) {
		this.monthlyQuarterlyTruckReport.data = [];
		const tableData = [];
		const sortedData = Object.keys(data).sort((a, b) => Number(a) - Number(b));
		for (const period of sortedData) {
			if (data.hasOwnProperty(period)) {
				const item = data[period];
				tableData.push({
					period: {value: this.selectedPeriodType == 'monthly' ? this.commonService.monthsText[item.month - 1] : item.quarter},
					trucks_count: {value: item.trucks_count || 0},
					used_trucks_count: {value: item.used_trucks_count || 0},
					score: {value: Math.round(item.truck_score || 0)},
					total_inuse_ah: {value: Math.round(item.total_discharged_as / 3600 || 0).toLocaleString()},
					energy_truck_score: {value: Math.round(item.truck_energy_score)},
					total_kwh_used: {value: Math.round(item.total_ws_used / (3600 * 1000) || 0).toLocaleString()},
					total_in_use_hours: {value: Math.round(item.total_in_use_second / 3600 || 0).toLocaleString()},
					total_travel_hours: {value: Math.round(item.total_travel_second / 3600 || 0).toLocaleString()},
					total_lift_hours: {value: Math.round(item.total_lift_second / 3600 || 0).toLocaleString()},
					total_idle_hours: {value: Math.round(item.total_idle_second / 3600 || 0).toLocaleString()},
					total_off_charging_hours: {value: Math.round(item.total_off_charging_second / 3600 || 0).toLocaleString()},
				});
			}
		}
		this.monthlyQuarterlyTruckReport.data = tableData;
		// A truck that never connected has no daily details, so the report comes back with no rows
		// at all. Show the message instead of an empty table.
		this.monthlyQuarterlyNoData = !tableData.length;
	}

	changeSelectedYearFilter() {
		this.getMonthlyQuarterlyUsageReport();
	}

	changePeriodType() {
		this.monthlyQuarterlyTruckReport.column[0].name = this.selectedPeriodType === 'monthly' ? this.translateService.instant('connectivity_verification.month') : this.translateService.instant('site.quarter');
		this.updateTableData(this.monthlyQuarterlyReportData?.[this.selectedPeriodType]?.[this.selectedYear] || []);
	}

	exportDataToCsv() {
		const csvFileHeaderInfo = this.commonService.getCsvFileHeadersInfo({
				customerName: this.siteInfo.customer_name,
				siteName: this.siteInfo.name
			});
		let csvData = [...csvFileHeaderInfo];
		for (let key in this.chartsData) {
			if (this.selectedGraphTypes === 'total' && key.indexOf('total') === -1)
				continue;

			if (this.selectedGraphTypes === 'average' && key.indexOf('average') === -1)
				continue;

			csvData.push([this.translateService.instant('fleet_reports.' + key)]);

			if (key == 'total_travel_lift_time')
				csvData.push([this.translateService.instant("g.time"), this.translateService.instant('usage_time_chart.travel_time'), this.translateService.instant('usage_time_chart.lift_time')]);
			else
				csvData.push([this.translateService.instant("g.time"), this.translateService.instant("g.data")]);

			let data = this.chartsData[key][this.monthlyDailySelectedYear] || [];
			// remove the tooltip column if it exists
			if (key.indexOf('inuse_hours') !== -1)
				data = data.map(row => row.slice(0, 2));
			if (key.indexOf('travel_lift_time') !== -1)
				data = data.map(row => [row[0], row[1], row[3]]);

			csvData.push(...data);
			csvData.push([]);
		}

		const selectedPeriodTypeLabel = this.dailyMonthlyPeriod.find((period) => period.id === this.selectedMonthlyDailyPeriod)?.label || this.translateService.instant('g.monthly');
		return new AngularCsv(csvData, `${selectedPeriodTypeLabel}_${this.translateService.instant('fleet_reports.truck_usage_chart')}`);
	}

	getMonthlyDailyChartsData() {
		const options = {
			is_daily: this.selectedMonthlyDailyPeriod == 'daily' ? true : false,
			year: this.monthlyDailySelectedYear,
			sct_devices_types: [DeviceFactory.types.iotah]
		}

		options['truckType'] = this.selectedMonthlyDailyTruckTypeFilter == 'all' ? '' : this.selectedMonthlyDailyTruckTypeFilter;

		this.siteService.getUsageChart(this.siteInfo.id, options).subscribe((res: any) => {
			res = this.prepareWidgetsTruckTypes(res);
			if (this.selectedMonthlyDailyPeriod == 'daily') {
				this.selectedGraphTypes = 'total'
				this.prepareDailyData(res)
			}
			else
				this.prepareMonthlyData(res);
		});
	}

	prepareDailyData(data) {
		this.resetCharts();
		const yearId = this.monthlyDailySelectedYear;
		this.chartsData.total_inuse_hours[yearId] = [];
		this.chartsData.total_inuse_ah[yearId] = [];
		this.chartsData.total_inuse_kwh[yearId] = [];
		this.chartsData.total_travel_lift_time[yearId] = [];
		this.chartObject.columnNames = [this.translateService.instant("g.time"), this.translateService.instant("g.data")];

		if (!data || !Object.keys(data).length)
			return this.noData = true;

		for (const day in data) {
			const date = data[day].day;
			const totalInuseAh = data[day].total_discharged_as ? +(data[day].total_discharged_as / 3600).toFixed(2) : 0;
			const totalInuseKwh = data[day].total_ws_used ? +(data[day].total_ws_used / (1000 * 3600)).toFixed(2) : 0;

			this.chartsData.total_inuse_hours[yearId].push([date, Math.round(data[day].total_in_use_second / 3600 || 0), this.commonService.formatPopupTime(data[day].total_in_use_second || 0, date)]);
			this.chartsData.total_inuse_ah[yearId].push([date, totalInuseAh || 0]);
			this.chartsData.total_inuse_kwh[yearId].push([date, totalInuseKwh || 0]);
			this.chartsData.total_travel_lift_time[yearId].push([
				date,
				Math.round(data[day].total_travel_second / 3600 || 0), this.commonService.formatPopupTime(data[day].total_travel_second || 0, date), // travel time
				Math.round(data[day].total_lift_second / 3600 || 0) || 0, this.commonService.formatPopupTime(data[day].total_lift_second || 0, date) // lift time
			]);
		}

		this.noData = false;
		this.travelLiftTimeChartConfig = {
			...this.timeChartConfig,
			series: {
				0: { targetAxisIndex: 0 },
				1: { targetAxisIndex: 0 }
			}
		}
	}

	resetCharts() {
		this.chartsData = {
			total_inuse_hours: {},
			total_inuse_ah: {},
			total_inuse_kwh: {},
			total_travel_lift_time: {},
			average_inuse_hours: {},
			average_inuse_ah: {},
			average_inuse_kwh: {},
			average_travel_lift_time: {},
		};
	}

	prepareMonthlyData(data) {
		this.resetCharts();

		if (!data || !Object.keys(data).length)
			return this.noData = true;

		for (let year of this.yearList) {
			const yearId = year.id;

			// total
			const totalInuseHours =  data?.data_total_inuse_duration_seconds?.[yearId] || [];
			const totalInuseAh = data.data_total_ahr?.[yearId] || [];
			const totalInuseKwh = data.data_total_kwhr?.[yearId] || [];
			const totalTravelTime = data.data_total_travel_time?.[yearId] || [];
			const totalLiftTime = data.data_total_lift_time?.[yearId] || [];

			// average
			const averageInuseHours = data.data_avg_inuse_duration_seconds?.[yearId] || [];
			const averageInuseAh = data.data_avg_ahr?.[yearId] || [];
			const averageInuseKwh = data.data_avg_kwhr?.[yearId] || [];
			const averageTravelTime = data.data_avg_travel_time?.[yearId] || [];
			const averageLiftTime = data.data_avg_lift_time?.[yearId] || [];

			if (
				!totalInuseHours.length || !totalInuseAh.length || !totalInuseKwh.length || !totalTravelTime.length || !totalLiftTime.length ||
				!averageInuseHours.length || !averageInuseAh.length || !averageInuseKwh.length || !averageTravelTime.length || !averageLiftTime.length
			) {
				continue;
			}

			this.noData = false;
			// total
			this.chartsData.total_inuse_hours[yearId] = [];
			this.chartsData.total_inuse_ah[yearId] = [];
			this.chartsData.total_inuse_kwh[yearId] = [];
			this.chartsData.total_travel_lift_time[yearId] = [];

			// average
			this.chartsData.average_inuse_hours[yearId] = [];
			this.chartsData.average_inuse_ah[yearId] = [];
			this.chartsData.average_inuse_kwh[yearId] = [];
			this.chartsData.average_travel_lift_time[yearId] = [];

			// total
			for(const period of totalInuseHours) {
				const data =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.total_inuse_hours[yearId].push([period[0], Math.round(data/3600 || 0), this.commonService.formatPopupTime(data || 0, period[0])]);
			}
			for(const period of totalInuseAh) {
				const data =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.total_inuse_ah[yearId].push([period[0], Math.round(data || 0)]);
			}
			for(const period of totalInuseKwh) {
				const data =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.total_inuse_kwh[yearId].push([period[0], Math.round(data || 0)]);
			}

			let periodIndex = 0;
			for(const period of totalTravelTime) {
				const totalTravel =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				const totalLift = _.sumBy(totalLiftTime[periodIndex].slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.total_travel_lift_time[yearId].push([
					period[0],
					Math.round(totalTravel/3600 || 0), this.commonService.formatPopupTime(totalTravel || 0, period[0]), // travel time
					Math.round(totalLift/3600 || 0), this.commonService.formatPopupTime(totalLift || 0, period[0]) // lift time
				]);
				periodIndex++;
			}

			// average
			for(const period of averageInuseHours) {
				const data =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.average_inuse_hours[yearId].push([period[0], Math.round(data/3600 || 0), this.commonService.formatPopupTime(data || 0, period[0])]);
			}
			for(const period of averageInuseAh) {
				const data =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.average_inuse_ah[yearId].push([period[0], +(data || 0).toFixed(1)]);
			}
			for(const period of averageInuseKwh) {
				const data =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.average_inuse_kwh[yearId].push([period[0], +(data || 0).toFixed(1)]);
			}

			periodIndex = 0;
			for(const period of averageTravelTime) {
				const totalTravelAvg =  _.sumBy(period.slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				const totalLiftAvg = _.sumBy(averageLiftTime[periodIndex].slice(1), val => isNaN(Number(val)) ? 0 : Number(val));
				this.chartsData.average_travel_lift_time[yearId].push([
					period[0],
					Math.round(totalTravelAvg/3600 || 0), this.commonService.formatPopupTime(totalTravelAvg || 0, period[0]), // travel time
					Math.round(totalLiftAvg/3600 || 0), this.commonService.formatPopupTime(totalLiftAvg || 0, period[0]) // lift time
				]);
				periodIndex++;
			}
		}

		this.checkSelectedYearData();
		this.travelLiftTimeChartConfig = {
			...this.timeChartConfig,
			 series: {
				0: { targetAxisIndex: 0 },
				1: { targetAxisIndex: 0 }
			}
		}
	}

	checkSelectedYearData() {
		this.noData = false;
		if (
			!this.chartsData.total_inuse_hours[this.monthlyDailySelectedYear]?.length &&
			!this.chartsData.total_inuse_ah[this.monthlyDailySelectedYear]?.length &&
			!this.chartsData.total_inuse_kwh[this.monthlyDailySelectedYear]?.length &&
			!this.chartsData.total_travel_lift_time[this.monthlyDailySelectedYear]?.length
		) {
			return this.noData = true;
		}
	}

	prepareWidgetsTruckTypes(response) {
		const deviceTruckTypes = [];
		deviceTruckTypes.push({value: 'all', label: this.translateService.instant('site_performance.all_truck_types')});
		if ('truckTypes' in response) {
			for (const truckType of response.truckTypes) {
				const alreadyExists = deviceTruckTypes.find(item => item.value == truckType.value);
				if (!alreadyExists)
					deviceTruckTypes.push(truckType);
			}
			delete response.truckTypes;
			this.truckTypeList = deviceTruckTypes;
		}
		return response;
	}

	ngOnDestroy() {
		this.subSite.unsubscribe();
	}
}
